import { render } from "./SaasClipboard.vue?vue&type=template&id=7db50620&scoped=true"
import script from "./SaasClipboard.vue?vue&type=script&lang=js"
export * from "./SaasClipboard.vue?vue&type=script&lang=js"

import "./SaasClipboard.vue?vue&type=style&index=0&id=7db50620&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db50620"]])

export default __exports__